import * as React from 'react';
import cn from 'classnames';
import { useTheme } from '../../theme';
import { useConfig } from '../../context';
const SimpleLoader = ({ isFullScreen = true }) => {
    var _a;
    const css = useTheme('SimpleLoader').SimpleLoaderStyles;
    const { Engine: { simpleLoaders } } = useConfig();
    const image = (_a = simpleLoaders === null || simpleLoaders === void 0 ? void 0 : simpleLoaders[0]) === null || _a === void 0 ? void 0 : _a.image;
    return (React.createElement("div", { className: cn(css.wrapper, { [css.wrapper_fullScreen]: isFullScreen }) },
        React.createElement("div", { className: css.loader, style: image ? { backgroundImage: `url(${image})` } : undefined })));
};
export default SimpleLoader;
